import ExpandedSalesSummaryComponent from './ExpandedSalesSummary';

const ExpandedSalesSummary = ExpandedSalesSummaryComponent;

export default ExpandedSalesSummary;
